module.exports = __webpack_public_path__ + "c8a45499ea59efff74c434075e71825f.pdf";